import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { BinOutlineSmall, ShareiosSmall, ShareSmall } from '@blueprint/icons';

const baseStyles = css`
    display: flex;
    position: relative;
    width: 100%;
    align-items: center;
    background: none;
    cursor: pointer;
`;

export const ActionList = styled('ul')(
    ({ theme: { mq, spacing, colors } }) => css`
        list-style-type: none;
        padding: 0;
        margin: 0;
        li {
            padding: 0;
            border-top: 1px solid ${colors['graphic-divider-light']};

            &:last-child {
                border-bottom: 1px solid ${colors['graphic-divider-light']};
            }
        }
        ${mq.medium} {
            margin: 0 -${spacing['8px']};
            display: flex;
            flex-wrap: wrap;
            li {
                width: calc(50% - ${spacing['16px']});
                margin: 0 ${spacing['8px']} ${spacing['8px']} ${spacing['8px']};
                border: 1px solid ${colors['graphic-divider-light']};
            }
        }
    `
);

export const ActionListItem = styled('li')();

export const ActionButton = styled('button')(
    ({ theme: { colors, focusRing, spacing } }) => css`
        ${baseStyles}
        border: none;
        color: ${colors['text-title']};
        padding: ${spacing['16px']};
        font-size: 1rem;
        font-family: inherit;
        line-height: 1.15;
        span {
            position: absolute;
            left: ${spacing['48px']};
        }
        &:focus {
            outline: none;
            box-shadow: ${focusRing};
        }
    `
);

export const BinOutlineColored = styled(BinOutlineSmall)(
    ({ theme: { colors } }) => css`
        color: ${colors['crimson']};
    `
);

export const ShareSmallColored = styled(ShareSmall)(
    ({ theme: { colors } }) => css`
        color: ${colors['purple-bright']};
    `
);

export const ShareiosSmallColored = styled(ShareiosSmall)(
    ({ theme: { colors } }) => css`
        color: ${colors['purple-bright']};
    `
);
